<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			theme: 'light' | 'dark';
			text: ISbRichtext;
			subline: ISbRichtext;
			cta: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section
	class={[
		'py-14 text-center lg:py-[168px]',
		{
			'bg-[#161D18] text-white': content.theme === 'dark',
			'bg-white text-brown-1': content.theme === 'light'
		}
	]}
	use:editable={content}
>
	<PageGrid16 margin>
		<div class="col-span-full text-balance lg:col-start-3 lg:col-end-[15]">
			<div
				class="general-impact-headline font-rhymes text-[40px]/[115%] font-light tracking-[-2%] lg:text-[64px]/[115%] lg:tracking-[-2%]"
				style="--highlight-text-color: {content.theme === 'dark' ? '#EBFF80' : '#158055'};
            --highlight-bg-color: {content.theme === 'dark' ? 'transparent' : '#DFEDDD'}"
			>
				<SbRichtext text={content.text} />
			</div>
			<div
				class={[
					'mx-2 mt-5 text-balance text-[12px]/[160%] lg:mt-6 lg:text-[14px]/[160%]',
					{
						'text-brown-4': content.theme === 'light'
					}
				]}
			>
				<SbRichtext text={content.subline} />
			</div>

			{#if content.cta?.length > 0}
				{#each content.cta as cta}
					<div class="mt-7 lg:mt-10">
						<Blok content={cta} />
					</div>
				{/each}
			{/if}
		</div>
	</PageGrid16>
</section>

<style>
	:global(.general-impact-headline .highlight) {
		color: var(--highlight-text-color);
		display: inline-block;
	}
</style>
